import { createAction } from '@wix/communities-blog-client-common';

export const ACTIONS_OPENED = 'moreButton/ACTIONS_OPENED';

export const actionsOpened = createAction(ACTIONS_OPENED);
